import type { UnitInfoBananaScreenInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export const TypeOfScreenings: string[] = ['Dry', 'Wet'];

export const nbrOfDecksOptions = [1, 2];

export const getDefaultData = (): UnitInfoBananaScreenInterface => {
  return {
    nbrOfDecks: 2,
    modelName: 'Multislope (generic)',
    width: 2.4,
    length: 6.1,
    deckList: {
      0: {
        separationSize: 25,
        screeningElement: { name: 'Square', value: 'SQUARE' },
        openArea: 50,
        particleShape: { name: 'Dry Cubical', value: 'DRY_CUBICAL' },
        efficiency: { name: 'Calc', value: 'CALC' },
        efficiencyNumber: 80,
        display: { separationSize: true },
      },
      1: {
        separationSize: 16,
        screeningElement: { name: 'Square', value: 'SQUARE' },
        openArea: 50,
        particleShape: { name: 'Dry Cubical', value: 'DRY_CUBICAL' },
        efficiency: { name: 'Calc', value: 'CALC' },
        efficiencyNumber: 80,
        display: { separationSize: true },
      },
    },
    scalpingScreen: false,
    wetScreening: false,
    materialType: { name: 'Broken Stone/Ore', value: 'BROKEN_STONE_OR_ORE' },
    moisture: 0,
    newMoisture: false,
    parallelUnits: 1,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayLoad: true,
      displayNbrOfDecks: false,
      displayWetScreening: false,
    },
  };
};

export class BananaScreenConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoBananaScreenInterface {
    return {
      nbrOfDecks: 2,
      modelName: 'Multislope (generic)',
      width: 2.4,
      length: 6.1,
      deckList: {
        0: {
          separationSize: 25,
          screeningElement: { name: 'Square', value: 'SQUARE' },
          openArea: 50,
          particleShape: { name: 'Dry Cubical', value: 'DRY_CUBICAL' },
          efficiency: { name: 'Calc', value: 'CALC' },
          efficiencyNumber: 80,
          display: { separationSize: true },
        },
        1: {
          separationSize: 16,
          screeningElement: { name: 'Square', value: 'SQUARE' },
          openArea: 50,
          particleShape: { name: 'Dry Cubical', value: 'DRY_CUBICAL' },
          efficiency: { name: 'Calc', value: 'CALC' },
          efficiencyNumber: 80,
          display: { separationSize: true },
        },
      },
      scalpingScreen: false,
      wetScreening: false,
      materialType: { name: 'Broken Stone/Ore', value: 'BROKEN_STONE_OR_ORE' },
      ...BaseUnitConfig.getBaseDefaults(),
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayNbrOfDecks: false,
        displayWetScreening: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 4;
  }
}

export const bananaScreenConfig = new BananaScreenConfig();
